import { Table, TableBody } from "@mui/material";

import ContactsTableHeader from "./ContactsTableHeader";
import ContactsTableItem from "./ContactsTableItem";

export default function ContactsTable({
  data,
  fieldOptions = [],
  contactTypeColors = {},
  permissions,
  editHandler,
  deleteHandler,
}) {
  return (
    <Table sx={{ minWidth: 650 }} aria-label="contacts table" stickyHeader>
      <ContactsTableHeader />
      <TableBody>
        {data.map((item) => (
          <ContactsTableItem
            key={item.id}
            contact={item}
            fieldOptions={fieldOptions}
            contactTypeColors={contactTypeColors}
            permissions={permissions}
            editHandler={editHandler}
            deleteHandler={deleteHandler}
          />
        ))}
      </TableBody>
    </Table>
  );
}
